export const SidebarTestIds = {
  sidenavContainer: 'sidenav_container',
  sidenavSidenav: 'sidenav_sidenav',
  sidebarHeaderIcon: 'sidebar_header_icon',
  searchInput: 'search_input',
  sidebarAccordion: 'sidebar_accordion',
  dropdownInvite: 'dropdown_invite',
  inviteRoomsDropdown: 'invite_rooms_dropdown',
  inviteCounterBadge: 'class_invite-counter-badge',
  dropdownChats: 'dropdown_chats',
  privateRoomsDropdown: 'private_rooms_dropdown',
  publicRoomsDropdown: 'public_rooms_dropdown',
  userDisplayName: 'user_display_name',
  bottomButtons: 'class_bottom_buttons',
  buttonLogout: 'button_logout',
  buttonSettingsmenu: 'button_settingsmenu',
  sidebarVersionText: 'sidebar_version_text',
  buttonToggleSideNav: 'button_toggleSideNav',
  mainContent: 'main_content',
  leaveAndForgetRoomsButton: 'leaveAndForgetRooms_button',
  nextLoginButton: 'nextLogin_button',
  deleteSettingsChangeButton: 'deleteSettingsChange_button',
  cardcontentChatsToDelete: 'cardcontent_chats_todelete',
  cardChatsToDelete: 'card_chats_todelete',
  cardheaderChatsToDelete: 'cardheader_chats_todelete',
  cardtitleChatsToDelete: 'cardtitle_chats_todelete',
  sidebarFooter: 'sidebar_footer',
  buttonSearch: 'button_search',
  buttonCreateroom: 'button_createroom',
  cardPublicChats: 'card_public_chats',
  buttonShowDevices: 'button_showDevices',
  buttonConfirmUpdates: 'button_confirm_updates',
  buttonConfirmPrivacy: 'button_confirm_privacy',
  buttonCancelJoin: 'button_cancel_join',
  buttonConfirmJoin: 'button_confirm_join',
  dialogJoinActions: 'dialog_join_actions',
  dialogJoinContent: 'dialog_join_content'
} as const;
